import { Link, NavLink } from 'react-router-dom';

import { getNavItems, NAV_ZONES } from './navigation.config';
import { useNavigation } from '../../hooks/useNavigation';
import ThemeAwareLogo from './ThemeAwareLogo';
import {
  normalizeUnreadCount,
  resolveNotificationNavPresentation,
} from '../../features/notifications/lib/unreadBadge';

export const MOBILE_OFFCANVAS_ID = 'mobile-more-menu';

const NAV_LINK_END_PATHS = new Set(['/', '/feed', '/profile']);

function MobileNavbar({ isAuthed = false, badges = {} }) {
  const { isOffcanvasOpen, openOffcanvas } = useNavigation();

  const items = getNavItems({
    zone: NAV_ZONES.MOBILE,
    isAuthed,
    badges,
  });

  return (
    <nav className="pNavbar-mobile" aria-label="Верхня панель">
      <div className="row m-0">
        <div className="nav-logo">
          <Link to="/feed" className="nav-text" aria-label="Рієстро — на головну">
            <ThemeAwareLogo
              className="nav-logo-img theme-aware-logo"
              lightSrc="/images/logo-nobg.png"
              darkSrc="/images/logo-dark-nobg.png"
            />
            <ThemeAwareLogo
              className="nav-logo-full theme-aware-logo"
              lightSrc="/images/logo-full-nobg.png"
              darkSrc="/images/logo-full-dark-nobg.png"
            />
          </Link>
        </div>

        <div className="pNavbar-mobile__right">
          {items.map((item) => {
            const isNotification = item.badgeKey === 'unreadNotifications';
            // 99+ cap + exact link a11y name are notification-only.
            // Non-notification badges (e.g. unreadChats) keep raw pre-D1 values.
            const presentation = isNotification
              ? resolveNotificationNavPresentation(item.label, item.badge)
              : {
                  linkAriaLabel: item.label,
                  badge: item.badge
                    ? {
                        display: String(item.badge),
                        ariaLabel: `${item.badge} непрочитаних`,
                      }
                    : null,
                };

            return (
              <NavLink
                key={item.id}
                to={item.to}
                end={NAV_LINK_END_PATHS.has(item.to)}
                className={({ isActive }) => `pmb-icon${isActive ? ' active' : ''}`}
                aria-label={presentation.linkAriaLabel}
              >
                <i className={item.iconClass} aria-hidden="true" />
                {presentation.badge ? (
                  <span
                    className="pmb-badge"
                    aria-hidden={isNotification ? 'true' : undefined}
                    aria-label={isNotification ? undefined : presentation.badge.ariaLabel}
                    data-unread-count={
                      isNotification
                        ? String(normalizeUnreadCount(item.badge))
                        : undefined
                    }
                  >
                    {presentation.badge.display}
                  </span>
                ) : null}
              </NavLink>
            );
          })}

          <button
            type="button"
            className="pmb-icon"
            aria-label="Додаткове меню"
            aria-expanded={isOffcanvasOpen}
            aria-controls={MOBILE_OFFCANVAS_ID}
            onClick={openOffcanvas}
          >
            <i className="fa-solid fa-bars" aria-hidden="true" />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default MobileNavbar;
